// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__XABpY","box":"style_box__TBYYt","active":"style_active__naKJa","title":"style_title__NfqjD","item":"style_item__9Kci9"};